import { Controller, MobileContextMenu } from '@tencent/workbench';
import { OcrFeature } from './ocr-feature';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { MOBILE_CONTEXTMENU_ITEMS, config } from './config';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { isMediaElement } from '@src/slide/domain/ui-model/elements/element-judge';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { isWeworkUser } from '@src/js/common/utils';
import { needHideOcrEntry } from '@src/slide/application/service/menu-manager/menu-items/right';

/**
 * 移动端 - ocr
 */
@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class OcrController {
    constructor(private readonly feature: OcrFeature) {}
    @MobileContextMenu(config.name, 'onClick')
    public setFocus() {
        this.feature.showOcr();
    }

    @MobileContextMenu(config.name, 'shouldHide')
    public shouldHide() {
        // 优先读CAC配置
        const enableOCR = DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.OCR) ?? true;
        if (!enableOCR || isWeworkUser()) {
            return true;
        }
        const model = this.feature.getSelectionService().selectedElements.getCurrentModel();
        const { lastMouseDownRegion } = this.feature.getSelectionService();

        if (model.type === UIModelType.IMAGE
            && !model.isAttachment()
            && !isMediaElement(model)
            && lastMouseDownRegion === RegionType.EDITOR
            && appConfigInstance.getConfig('feature.ocrMobile')
            && !needHideOcrEntry(model)
        ) {
            return false;
        }
        return true;
    }
}
